import { render, staticRenderFns } from "./fidelity-inscription.vue?vue&type=template&id=7d9d8148"
import script from "./fidelity-inscription.vue?vue&type=script&lang=ts"
export * from "./fidelity-inscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9d8148')) {
      api.createRecord('7d9d8148', component.options)
    } else {
      api.reload('7d9d8148', component.options)
    }
    module.hot.accept("./fidelity-inscription.vue?vue&type=template&id=7d9d8148", function () {
      api.rerender('7d9d8148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "fidelity/fidelity-inscription.vue"
export default component.exports